import React from 'react'
import constants from '../ndbk-constants'
import Utils from './Utils'

class ParseButton extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isParsing: false
        }
    }

    render() {
        return (
            <span onClick={()=>{
                if (!this.state.isParsing) {
                    this.setState({isParsing: true}, ()=>{
                        var node = this.props.node
                        fetch(`https://${constants.SERVER_IP}/api/file/parse`, {
                            method: 'POST',
                            body: JSON.stringify({
                                url: this.props.url,
                            }),
                            headers: {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json',
                            },
                            credentials: 'include',
                        })
                            .then(response => response.json())
                            .then(response => {
                                if (response.success) {
                                    this.setState({
                                        isParsing: false
                                    }, ()=>{
                                        this.props.selectionUpdateAllLocalFirst(response.data, {nodes: [node.id], links: []}, this.props.onChange)
                                    })
                                } else {
                                    this.setState({
                                        isParsing: false
                                    })
                                }
                                return response.success
                            })
                            .catch(()=>{})
                        })
                    }
                }}
                title={this.state.isParsing?'Parsing in progress...':'Parse document'}
                className={this.state.isParsing?'forceVisible':''}
            >
            {
                (!this.state.isParsing)
                    ? (
                        <svg width="14" height="14" viewBox="0 0 20 20">
                            <path d="M5 15c-0.128 0-0.256-0.049-0.354-0.146l-4-4c-0.195-0.195-0.195-0.512 0-0.707l4-4c0.195-0.195 0.512-0.195 0.707 0s0.195 0.512 0 0.707l-3.646 3.646 3.646 3.646c0.195 0.195 0.195 0.512 0 0.707-0.098 0.098-0.226 0.146-0.354 0.146z"></path>
                            <path d="M15 15c-0.128 0-0.256-0.049-0.354-0.146-0.195-0.195-0.195-0.512 0-0.707l3.646-3.646-3.646-3.646c-0.195-0.195-0.195-0.512 0-0.707s0.512-0.195 0.707 0l4 4c0.195 0.195 0.195 0.512 0 0.707l-4 4c-0.098 0.098-0.226 0.146-0.354 0.146z"></path>
                            <path d="M7.5 15c-0.091 0-0.182-0.025-0.265-0.076-0.234-0.146-0.305-0.455-0.159-0.689l5-8c0.146-0.234 0.455-0.305 0.689-0.159s0.305 0.455 0.159 0.689l-5 8c-0.095 0.152-0.258 0.235-0.424 0.235z"></path>
                        </svg>
                    ) : (
                        <svg width="14" height="14" viewBox="0 0 20 20">
                            <path d="M16 3.5v-0.5c0-0.392-0.241-0.733-0.717-1.014-0.344-0.203-0.821-0.382-1.419-0.531-1.172-0.293-2.722-0.454-4.364-0.454s-3.192 0.161-4.364 0.454c-0.598 0.149-1.075 0.328-1.419 0.531-0.476 0.281-0.717 0.622-0.717 1.014v0.5c0 2.631 1.593 4.999 4 6.002v1.997c-2.407 1.003-4 3.371-4 6.002v0.5c0 0.392 0.241 0.733 0.717 1.014 0.344 0.203 0.821 0.382 1.419 0.531 1.172 0.293 2.722 0.454 4.364 0.454s3.192-0.161 4.364-0.454c0.598-0.149 1.075-0.328 1.419-0.531 0.476-0.281 0.717-0.623 0.717-1.014v-0.5c0-2.631-1.593-4.999-4-6.002v-1.997c2.407-1.003 4-3.371 4-6.002zM5.612 2.369c1.066-0.238 2.447-0.369 3.888-0.369s2.823 0.131 3.888 0.369c1.15 0.257 1.498 0.534 1.589 0.631-0.091 0.097-0.439 0.374-1.589 0.631-1.066 0.238-2.447 0.369-3.888 0.369s-2.823-0.131-3.888-0.369c-1.15-0.257-1.498-0.534-1.589-0.631 0.091-0.097 0.439-0.374 1.589-0.631zM11.333 12.313c2.193 0.775 3.667 2.86 3.667 5.187v0.473c-0.042 0.057-0.324 0.37-1.612 0.657-1.066 0.238-2.447 0.369-3.888 0.369s-2.823-0.131-3.888-0.369c-1.287-0.288-1.57-0.6-1.612-0.657v-0.473c0-2.327 1.473-4.412 3.667-5.187 0.2-0.071 0.333-0.259 0.333-0.471v-2.683c0-0.212-0.134-0.401-0.333-0.471-1.976-0.699-3.368-2.461-3.624-4.506 0.3 0.135 0.666 0.257 1.093 0.364 1.172 0.293 2.722 0.454 4.364 0.454s3.192-0.161 4.364-0.454c0.428-0.107 0.794-0.229 1.093-0.364-0.256 2.045-1.647 3.807-3.624 4.506-0.2 0.071-0.333 0.26-0.333 0.471v2.683c0 0.212 0.134 0.401 0.333 0.471z"></path>
                            <path d="M13.667 16.529c-2.262-0.799-3.667-2.726-3.667-5.029v-3.025c0.6-0.059 1.178-0.225 1.723-0.495 0.247-0.123 0.348-0.423 0.225-0.67s-0.423-0.348-0.67-0.225c-0.555 0.276-1.153 0.416-1.778 0.416s-1.223-0.14-1.778-0.416c-0.247-0.123-0.547-0.022-0.67 0.225s-0.022 0.547 0.225 0.67c0.545 0.271 1.122 0.436 1.723 0.495v3.025c0 2.302-1.405 4.229-3.667 5.029-0.21 0.074-0.346 0.279-0.332 0.501s0.172 0.409 0.39 0.458c0.982 0.22 2.477 0.512 4.109 0.512s3.127-0.292 4.109-0.512c0.218-0.049 0.377-0.236 0.39-0.458s-0.122-0.427-0.332-0.501zM9.5 17c-0.877 0-1.701-0.087-2.437-0.205 0.665-0.421 1.244-0.952 1.711-1.575 0.293-0.391 0.536-0.812 0.726-1.254 0.19 0.442 0.433 0.863 0.726 1.254 0.466 0.622 1.045 1.153 1.711 1.575-0.736 0.117-1.56 0.205-2.437 0.205z"></path>
                        </svg>
                    )
            }
            </span>
        )
    }
}

export default class FilesList extends React.Component {
     constructor(props) {
        super(props)
        // this.state = {
        //     node: this.props.node
        // }
    }

    // componentWillReceiveProps (nextProps) {
    //     if (nextProps.defaultValue !== this.state.value) {
    //         this.setState({
    //             node: nextProps.node
    //         })
    //     }
    // }

    removeFile = (file) => {
        let node = this.props.node
        let newFiles = []
        node.properties.files.forEach(f=>{
            if (f!==file) {
                newFiles.push(f)
            }
        })

        node.properties.files = newFiles
        let remoteFilesData = node.properties.files.filter(f=>f.url!=='').map(f=>{
            return {
                url: f.url,
                date: f.date,
                name: f.name,
                size: f.size
            }
        })

        this.props.selectionUpdateAllLocalFirst({files:remoteFilesData}, {nodes: [node.id], links: []})

        // this.props.updateNodesRemotely([node.id], {
        //     files: remoteFilesData
        // }, ()=>{
        //     this.forceUpdate()
        // })
    }

    uploadFile = (file) => {
        if (!file) {
            return
        }

        (()=>{
            var node = this.props.node

            let newFileObj = {
                isUploading: true,
                uploadPercent: 0,
                isValid: false,
                url: '',
                date: null,
                name: file.name,
                size: file.size,
            }

            let fileTooBig = (file.size >= 100*1024*1024)
            if (fileTooBig) {
                newFileObj.isValid = false
                newFileObj.isUploading = false
            }

            node.properties.files = [...node.properties.files, newFileObj]
            this.forceUpdate()

            if (fileTooBig) {
                return
            }

            var xhr = new XMLHttpRequest()
            xhr.upload.addEventListener("progress", e => {
                var pc = Math.floor(e.loaded / e.total * 100)
                newFileObj.uploadPercent = pc
                if (node._selectionId!==-1) {
                    this.forceUpdate()
                }
            }, false);
            xhr.onreadystatechange = e => {
                if (xhr.readyState === 4) {
                    let response = JSON.parse(xhr.response)
                    newFileObj.isUploading = false
                    newFileObj.isValid = response.success
                    newFileObj.date = Date.now()
                    newFileObj.url = (response.success)?response.data.file:''

                    if (node._selectionId!==-1) {
                        this.forceUpdate()
                    }

                    if (response.success) {
                        let remoteFilesData = node.properties.files.filter(f=>f.url!=='').map(f=>{
                            return {
                                url: f.url,
                                date: f.date,
                                name: f.name,
                                size: f.size
                            }
                        })
                        this.props.selectionUpdateAllLocalFirst({ files:remoteFilesData}, {nodes: [node.id], links: []})
                        // this.props.updateNodesRemotely([node.id], {
                        //     files: remoteFilesData
                        // })
                    }
                }
            }
            xhr.open("POST", `https://${constants.SERVER_IP}/api/file/upload`, true)
            xhr.withCredentials = true
            let formData = new FormData()
            formData.append('file', file)
            xhr.send(formData)
        })()
    }


    render() {
        return (
            <p className="files">
                {
                    (this.props.disabled)
                        ? <strong>Files</strong>
                        : (
                            <label>
                                <svg width="16" height="16" viewBox="0 0 20 20">
                                    <path d="M17.854 5.646l-4.5-4.5c-0.094-0.094-0.221-0.146-0.354-0.146h-9.5c-0.827 0-1.5 0.673-1.5 1.5v16c0 0.827 0.673 1.5 1.5 1.5h13c0.827 0 1.5-0.673 1.5-1.5v-12.5c0-0.133-0.053-0.26-0.146-0.354zM16.793 6h-3.293c-0.276 0-0.5-0.224-0.5-0.5v-3.293l3.793 3.793zM16.5 19h-13c-0.276 0-0.5-0.224-0.5-0.5v-16c0-0.276 0.224-0.5 0.5-0.5h8.5v3.5c0 0.827 0.673 1.5 1.5 1.5h3.5v11.5c0 0.276-0.224 0.5-0.5 0.5z"></path>
                                    <path d="M11.5 13h-2.5v-2.5c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v2.5h-2.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h2.5v2.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-2.5h2.5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5z"></path>
                                </svg>
                                Add file
                                <input type="file" multiple={true} onChange={e=>{
                                    for (let i=0; i<e.target.files.length; i++) {
                                        this.uploadFile(e.target.files[i])
                                    }
                                }}/>
                            </label>
                        )
                }
                {
                    this.props.node.properties.files.map((file,id)=>(
                        <span key={file.url+(id+1)} style={{display: 'block'}}>
                            {
                                (file.isValid===false)
                                    ? (!file.isUploading)
                                        ? <a><span style={{fontSize: '10px', color: 'red'}}>(failed)</span> <span style={{color: '#888'}}>{file.name}</span></a>
                                        : <a><span style={{fontSize: '10px', color: '#7AABFD'}}>({file.uploadPercent}%)</span> <span style={{color: '#888'}}>{file.name}</span></a>
                                    : <a target="_blank" title={file.name} href={file.url}><span style={{fontSize: '10px', color: '#888'}}>{file.size?`(${Utils.parseFileSize(file.size)})`:''}</span>{file.name}</a>
                            }
                            {
                                (this.props.disabled || file.url==='')
                                    ? null
                                    : <ParseButton
                                        url={file.url}
                                        node={this.props.node}
                                        selectionUpdateAllLocalFirst={this.props.selectionUpdateAllLocalFirst}
                                        onChange={this.props.onChange}
                                    />
                            }
                            {
                                (this.props.disabled || file.url==='')
                                    ? null
                                    : (
                                        <svg width="12" height="12" viewBox="0 0 20 20" title="Remove file" onClick={()=>{this.removeFile(file)}}>
                                            <path d="M10.707 10.5l5.646-5.646c0.195-0.195 0.195-0.512 0-0.707s-0.512-0.195-0.707 0l-5.646 5.646-5.646-5.646c-0.195-0.195-0.512-0.195-0.707 0s-0.195 0.512 0 0.707l5.646 5.646-5.646 5.646c-0.195 0.195-0.195 0.512 0 0.707 0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146l5.646-5.646 5.646 5.646c0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146c0.195-0.195 0.195-0.512 0-0.707l-5.646-5.646z"></path>
                                        </svg>
                                    )
                            }
                        </span>
                    ))
                }
            </p>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/FilesList.js